import { Dispatch, SetStateAction, useState } from "react";
import { Modal, Button, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGenerateLinkMutation } from "../service/user";
import { showError, showToast } from "../constants/toasts";
import { isValidNumber } from "../utils/validations";
interface RejectReasonModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  type?: "offerManagement" | "userManagement";
  userId?: string;
  setLoading: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
}

export default function GenerateLink({
  open,
  onClose,
  setOpen,
  type = "offerManagement",
  userId,
  setLoading,
  loading,
}: RejectReasonModalProps) {
  const [generateLink] = useGenerateLinkMutation();
  const [amount, setAmount] = useState("");
  const [error, setError] = useState(false);
  const [notes, setNotes] = useState("");

  const generateLinkApi = async () => {
    setError(true);
    if (!amount || !notes) {
      return;
    }

    try {
      setLoading(true);

      const body = {
        userId: userId,
        amount,
        notes,
      };
      const response = await generateLink(body).unwrap();
      setLoading(false);

      if (response.status === 200) {
        setError(false);
        showToast(response?.message || "");
        setAmount("");
        setNotes("");
        setOpen(false);
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Generate Link</h2>
            <div
              role="button"
              tabIndex={0}
              className="btn-close"
              onClick={() => {
                setAmount("");
                setError(false);
                setOpen(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <form className="form">
            {type === "offerManagement" && (
              <div className="control_group">
                <label htmlFor="email">Email Address</label>
                <TextField
                  id="email"
                  placeholder="Enter email"
                  fullWidth
                  hiddenLabel
                ></TextField>
              </div>
            )}
            <div className="control_group">
              <label htmlFor="amount">Amount</label>
              <TextField
                id="amount"
                placeholder="Enter amount"
                fullWidth
                hiddenLabel
                inputProps={{ maxLength: 10 }}
                value={amount}
                onChange={(e) => {
                  const { value } = e.target;
                  if (isValidNumber(value)) {
                    setAmount(value);
                  }
                }}
              />
              {error && !amount ? (
                <p className="err_msg">Amount is required</p>
              ) : (
                ""
              )}
            </div>

            <div className="control_group">
              <TextField
                placeholder="Enter Note"
                fullWidth
                hiddenLabel
                multiline={true}
                minRows={3}
                value={notes}
                inputProps={{ maxLength: 150 }}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setNotes(e.target.value);
                  }
                }}
              />
              {error && notes == "" ? (
                <h6 className="err_msg">Note is required</h6>
              ) : (
                ""
              )}
            </div>

            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={generateLinkApi}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
